import { CONSTANTS } from './constants';

export function createType (reducer, base) {
  return `${reducer}/${base}`;
}

export function createRequestTypes (reducer, base) {
  return ['REQUEST', 'SUCCESS', 'FAILURE', 'REFRESH'].reduce((acc, type) => {
    acc[type] = `${createType(reducer, base)}_${type}`;
    return acc;
  }, { reducerKey: reducer, actionKey: base });
}

export function action (type, payload = {}) {
  return { type, ...payload };
}

export const createReducer = (actionType, initialState) => {
  return function reducer (state = initialState, Action) {
    switch (Action.type) {
      case CONSTANTS[actionType].REQUEST:
        return {
          ...state,
          loading: true,
          error: false,
          reason: null,
          refresh: false,
          data: null // reset data on new request
        };
      case CONSTANTS[actionType].SUCCESS:
        return {
          ...state,
          data: Action.payload,
          loading: false,
          error: false,
          reason: null,
          refresh: false
        };
      case CONSTANTS[actionType].FAILURE:
        return {
          ...state,
          loading: false,
          reason: Action.reason,
          errorData: Action.errorData,
          error: true,
          refresh: false
        };
      case CONSTANTS[actionType].REFRESH:
        return {
          ...state,
          loading: false,
          reason: Action.reason,
          error: false,
          refresh: true
        };
      default:
        return state;
    }
  };
};

export const createActions = (actionType) => {
  return {
    refresh: data => action(CONSTANTS[actionType].REFRESH, { data }),
    request: data => action(CONSTANTS[actionType].REQUEST, { data }),
    success: data => action(CONSTANTS[actionType].SUCCESS, { data }),
    failure: (data, error) =>
      action(CONSTANTS[actionType].FAILURE, { data, error })
  };
};
